import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { Certification } from '@models';

import { faBadgeCheck } from '@icons/solid/faBadgeCheck';
import { faBan } from '@icons/solid/faBan';
import { faClock } from '@icons/solid/faClock';
import { faTimes } from '@icons/solid/faTimes';

/**
 * `PopoverVerificationInfo` component properties.
 */
export interface Props {
  target: string;
  status: Certification.Status;
}

interface StatusInfo {
  text: string;
  color: string;
  icon: IconDefinition | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PopoverVerificationInfo',
  props: {
    target: null,
    status: null
  },
  setup(__props: any) {

const props = __props as {
  target: string;
  status: Certification.Status;
};



const info = computed(() => {
  let value: StatusInfo | null = null;

  if (props.status === 'CURRENT') {
    value = { text: 'Active', color: '#15d246', icon: faBadgeCheck };
  } else if (props.status === 'EXPIRED') {
    value = { text: 'Expired', color: '#ff004f', icon: faClock };
  } else if (props.status === 'SUSPENDED') {
    value = { text: 'Suspended', color: '#ff004f', icon: faTimes };
  } else if (props.status === 'REVOKED') {
    value = { text: 'Revoked', color: '#ff004f', icon: faBan };
  } else {
    value = { text: '', color: 'currentColor', icon: null };
  }

  return value;
});

return { __sfc: true,props, info }
}

})